<template>
  <div>
    <Packages />
  </div>
</template>

<script>
import Packages from "./Packages";

export default {
  name: "PaymentUpgrade",
  components: {
    Packages
  }
}
</script>

<style scoped>

</style>
